import moment from 'moment'

const S_Pattern = 'YYYY-MM-DD HH:mm:ss'
const MINUTE_Pattern = 'YYYY-MM-DD HH:mm'
/* const HOUR_Pattern = 'YYYY-MM-DD HH'*/
/* const DAY_Pattern = 'YYYY-MM-DD'*/
const MONTH_Pattern = 'YYYY-MM'
const YEAR_Pattern = 'YYYY'
const HOUR_Pattern = 'HH:mm'
const DAY_Pattern = 'YYYY-MM-DD'
export function format(time, pattern) {
  return moment(time).format(pattern)
}

export function formatToSecond(time) {
  return format(time, S_Pattern)
}

export function formatToMinute(time) {
  return format(time, MINUTE_Pattern)
}

export function formatToHour(time) {
  return format(time, HOUR_Pattern)
}

export function formatToDay(time) {
  return format(time, DAY_Pattern)
}

export function formatToMonth(time) {
  return format(time, MONTH_Pattern)
}

export function formatToYear(time) {
  return format(time, YEAR_Pattern)
}

/**
 * 获取某天天0点时间戳
 */
export function getCurrDayZero(time) {
  const date = time || new Date()
  date.setMilliseconds(0)
  date.setSeconds(0)
  date.setMinutes(0)
  date.setHours(0)
  return date.getTime()
}

/**
 * 获取当天最后一秒时间戳
 */
export function getCurrDayLast(time) {
  return getCurrDayZero(time) + (24 * 60 * 60 * 1000) - 1
}

var now = new Date() // 当前时间
var nowDayOfWeek = now.getDay() - 1// 今天本周的第几天
var nowDay = now.getDate() // 当前日
var nowMonth = now.getMonth() // 当前月
var nowYear = now.getYear() // 当前年
nowYear += (nowYear < 2000) ? 1900 : 0

// 格式化时间：yyyy-MM-dd
export function formatDate(date) {
  var myyear = date.getFullYear()
  var mymonth = date.getMonth() + 1
  var myweekday = date.getDate()

  if (mymonth < 10) {
    mymonth = '0' + mymonth
  }
  if (myweekday < 10) {
    myweekday = '0' + myweekday
  }
  return (myyear + '-' + mymonth + '-' + myweekday)
}

// 获得某月的天数
function getMonthDays(myMonth) {
  var monthStartDate = new Date(nowYear, myMonth, 1)
  var monthEndDate = new Date(nowYear, myMonth + 1, 1)
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
  return days
}

// 获得本日的开始时间
export function getDayStartDate() {
  return formatDate(now) + ' 00:00:00'
}

// 获得本日的结束时间
export function getDayEndDate() {
  return formatDate(now) + ' 23:59:59'
}

// 获得昨日的开始时间
function getYesterdayStartDate() {
  var yesterdayStart = new Date(getDayStartDate()).getTime() - (24 * 60 * 60 * 1000)
  return formatDate(new Date(yesterdayStart)) + ' 00:00:00'
}
// 获得昨日的结束时间
function getYesterdayEndDate() {
  var yesterdayEnd = new Date(getDayEndDate()).getTime() - (24 * 60 * 60 * 1000)
  return formatDate(new Date(yesterdayEnd)) + ' 23:59:59'
}

// 获得本周的开始时间
function getWeekStartDate() {
  var weekStartDate
  if (nowDayOfWeek === -1) {
    weekStartDate = new Date(nowYear, nowMonth, nowDay -6)
  } else {
    weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek)
  }
  return formatDate(weekStartDate) + ' 00:00:00'
}

// 获得本周的结束时间
function getWeekEndDate() {
  var weekEndDate
  if (nowDayOfWeek === -1) {
    weekEndDate = new Date(nowYear, nowMonth, nowDay)
  } else {
    weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
  }
  return formatDate(weekEndDate) + ' 23:59:59'
}

// 获得上周的开始时间
function getLastWeekStartDate() {
  var lastStart = new Date(getWeekStartDate()).getTime() - (7 * 24 * 60 * 60 * 1000)
  return formatDate(new Date(lastStart)) + ' 00:00:00'
}

// 获得上周的结束时间
function getLastWeekEndDate() {
  var lastEnd = new Date(getWeekEndDate()).getTime() - (7 * 24 * 60 * 60 * 1000)
  return formatDate(new Date(lastEnd)) + ' 23:59:59'
}

// 获得本月的开始时间
function getMonthStartDate() {
  var monthStartDate = new Date(nowYear, nowMonth, 1)
  return formatDate(monthStartDate) + ' 00:00:00'
}

// 获得本月的结束时间
function getMonthEndDate() {
  var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth))
  return formatDate(monthEndDate) + ' 23:59:59'
}

// 获得上月的开始时间
function getLastMonthStartDate() {
  var lastMonthStartDate = new Date(getMonthStartDate()).getTime() - (getMonthDays(nowMonth - 1) * 24 * 60 * 60 * 1000)
  return formatDate(new Date(lastMonthStartDate)) + ' 00:00:00'
}

// 获得上月的结束时间
function getLastMonthEndDate() {
  var lastMonthEndDate = new Date(getMonthEndDate()).getTime() - (getMonthDays(nowMonth) * 24 * 60 * 60 * 1000)
  return formatDate(new Date(lastMonthEndDate)) + ' 23:59:59'
}

// 获得本年的开始时间
export function getYearStartDate() {
  // 获得当前年份4位年
  var currentYear = now.getFullYear()
  // 本年第一天
  var currentYearFirstDate = new Date(currentYear, 0, 1)
  return formatDate(currentYearFirstDate) + ' 00:00:00'
}

// 获得本年的结束时间
export function getYearEndDate() {
  // 获得当前年份4位年
  var currentYear = now.getFullYear()
  // 本年最后
  var currentYearLastDate = new Date(currentYear, 11, 31)
  return formatDate(currentYearLastDate) + ' 23:59:59'
}

// 获得上年的开始时间
function getLastYearStartDate() {
  // 获得当前年份4位年
  var lastYear = now.getFullYear() - 1
  // 本年第一天
  var currentYearFirstDate = new Date(lastYear, 0, 1)
  return formatDate(currentYearFirstDate) + ' 00:00:00'
}

// 获得上年的结束时间
function getLastYearEndDate() {
  // 获得当前年份4位年
  var lastYear = now.getFullYear() - 1
  // 本年最后
  var currentYearLastDate = new Date(lastYear, 11, 31)
  return formatDate(currentYearLastDate) + ' 23:59:59'
}

export function getStartAndEnd(dayType, dateUnit) {
  if (dayType === 'now') {
    switch (dateUnit) {
      case 'day':
        return { start: new Date(getDayStartDate()), end: new Date(getDayEndDate()) }
      case 'week':
        return { start: new Date(getWeekStartDate()), end: new Date(getWeekEndDate()) }
      case 'month':
        return { start: new Date(getMonthStartDate()), end: new Date(getMonthEndDate()) }
      case 'year':
        return { start: new Date(getYearStartDate()), end: new Date(getYearEndDate()) }
      default :
        return { start: new Date(getDayStartDate()), end: new Date(getDayEndDate()) }
    }
  } else {
    switch (dateUnit) {
      case 'day':
        return { start: new Date(getYesterdayStartDate()), end: new Date(getYesterdayEndDate()) }
      case 'week':
        return { start: new Date(getLastWeekStartDate()), end: new Date(getLastWeekEndDate()) }
      case 'month':
        return { start: new Date(getLastMonthStartDate()), end: new Date(getLastMonthEndDate()) }
      case 'year':
        return { start: new Date(getLastYearStartDate()), end: new Date(getLastYearEndDate()) }
      default :
        return { start: new Date(getDayStartDate()), end: new Date(getDayEndDate()) }
    }
  }
}
